/**
 * OpenAI API Key patterns:
 *
 * 1. Project/Service Account/Admin API Keys (newer format):
 *    - Starts with 'sk-proj-', 'sk-svcacct-', or 'sk-admin-'
 *    - Followed by 74 or 58 alphanumeric characters, hyphens, and underscores
 *    - Contains 'T3BlbkFJ' (base64 for 'OpenAI')
 *    - Followed by another 74 or 58 alphanumeric characters, hyphens, and underscores
 *
 * 2. Legacy API Keys:
 *    - Starts with 'sk-'
 *    - Followed by 20 alphanumeric characters
 *    - Contains 'T3BlbkFJ' (base64 for 'OpenAI')
 *    - Followed by 20 more alphanumeric characters
 *
 * Examples:
 * - Project Key: `sk-proj-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXT3BlbkFJXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX`
 * - Legacy Key: `sk-XXXXXXXXXXXXXXXXXXXX-T3BlbkFJ-XXXXXXXXXXXXXXXXXXXX`
 *
 * References:
 * - https://platform.openai.com/docs/api-reference/authentication
 * - https://help.openai.com/en/articles/4936850-where-do-i-find-my-api-key
 */

export const openaiApiKey =
  /sk-(?:proj|svcacct|admin)-(?:[A-Za-z0-9_-]{74}|[A-Za-z0-9_-]{58})T3BlbkFJ(?:[A-Za-z0-9_-]{74}|[A-Za-z0-9_-]{58})\b|sk-[a-zA-Z0-9]{20}T3BlbkFJ[a-zA-Z0-9]{20}/;
